document.addEventListener('click', function(e) {
  if (!e.target.closest('.js-add-kit')) return;

  const button = e.target.closest('.js-add-kit');
  const variantId = button.dataset.variantId;

  fetch(theme.routes.cartAdd, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
  .then(response => response.json())
  .then(() => {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  })
  .catch(error => console.log(error));
});